module.exports = __webpack_public_path__ + "static/benefits4-f4ee5225477ebed8f49d0e9d7960737b.png";